// extracted by mini-css-extract-plugin
export var filterIncDec = "_di-0";
export var leftBorder = "_di-1";
export var rightBorder = "_di-2";
export var stringInput = "_di-3";